import _slicedToArray from "/home/bcl-presale-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useEffect, useRef, useState } from 'react';
import { isInBrowser } from '@tronweb3/tronwallet-abstract-adapter';
export function useLocalStorage(key, defaultState) {
  var _useState = useState(function () {
    try {
      var value = localStorage.getItem(key);
      if (value) return JSON.parse(value);
    } catch (error) {
      if (isInBrowser()) {
        console.error(error);
      }
    }

    return defaultState;
  }),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  var isFirstRender = useRef(true);
  useEffect(function () {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    try {
      if (state === null) {
        localStorage.removeItem(key);
      } else {
        localStorage.setItem(key, JSON.stringify(state));
      }
    } catch (error) {
      if (isInBrowser()) {
        console.error(error);
      }
    }
  }, [state, key]);
  return [state, setState];
}